export var ExportType;
(function (ExportType) {
    ExportType["product"] = "product_based";
    ExportType["timeRange"] = "time_range";
})(ExportType || (ExportType = {}));
